var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 36.4156C12.5444 36.4156 9.71105 33.5844 9.71105 30.1267C9.71105 28.3979 10.3823 26.8623 11.5354 25.7111L14.9911 21.5823C15.5198 20.9579 16.5267 20.9579 17.0554 21.5823L20.5111 25.7111C21.6154 26.8623 22.3354 28.3998 22.3354 30.1267C22.2886 33.5842 19.4555 36.4156 16 36.4156Z",
    fill: "#FFC629"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0711 11.6956L24.5911 11.3113C24.0154 10.8313 23.1023 11.0225 22.7667 11.6956C22.6223 12.0313 22.4779 15.3912 22.4779 15.9669V16.3025C22.4779 16.7825 22.0467 17.1669 21.5667 17.0713C21.1823 17.0225 20.8955 16.64 20.8955 16.2556C20.8467 10.4956 19.1198 6.4646 15.8555 3.44012C13.8867 1.61573 11.5355 -0.0154971 10.8155 1.23135C10.6242 1.56698 10.9111 2.28697 11.2467 3.20012C11.9179 5.2645 9.85547 8.57564 6.92671 11.8891C4.19109 15.0091 0.782227 18.8491 0.782227 24.5601C0.782227 32.2401 8.03119 39.2001 15.9977 39.2001C23.9667 39.2001 31.2133 32.2401 31.2133 24.5601C31.2151 19.7112 28.9111 14.9111 25.0711 11.6956ZM9.71105 30.1267C9.71105 33.5844 12.5444 36.4156 16 36.4156C19.4555 36.4156 22.2886 33.5842 22.3354 30.1267C22.3354 28.3998 21.6154 26.8623 20.5111 25.7111L17.0554 21.5823C16.5267 20.9579 15.5198 20.9579 14.9911 21.5823L11.5354 25.7111C10.3823 26.8623 9.71105 28.3979 9.71105 30.1267Z",
    fill: "#FA553A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.9f5942e7.svg";
export { ForwardRef as ReactComponent };